import { useContext, useEffect } from "react";
import { SidePaneContext } from "./context";
import { useUserPreference } from "../../Hooks/useUserPreference";

function Content({ children }) {
	const { setSidePaneContent } = useContext(SidePaneContext);
	const { showSidePane, notificationsOverride } = useUserPreference();

	useEffect(() => {
		if (children && !notificationsOverride) {
			showSidePane(true);
		}
		return () => {
			showSidePane(false);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		setSidePaneContent(children || null);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [children]);

	useEffect(() => {
		return () => {
			setSidePaneContent(null);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);
}

export default Content;
